import { CreateDateModal } from '../../Modals/Create';
import { DeleteDateModal } from '../../Modals/Delete';
import { EditDateModal } from '../../Modals/Edit';
import { ProductionCalendarTabs } from '../../Tabs';
import { useProductionCalendarService } from '../model';

export const ProductionCalendar = () => {
  const {
    state: {
      selectedTab,
      createModalVisible,
      selectedMonth,
      refreshTrigger,
      selectedCalendarEvent,
      editModalVisible,
      deleteModalVisible,
    },
    methods: {
      setSelectedTab,
      hideCreateModal,
      showCreateModal,
      refreshData,
      showEditModal,
      hideEditModal,
      showDeleteModal,
      hideDeleteModal,
    },
  } = useProductionCalendarService();

  return (
    <>
      <ProductionCalendarTabs
        selectedTab={selectedTab}
        onSelectTab={setSelectedTab}
        showCreateModal={showCreateModal}
        refreshTrigger={refreshTrigger}
        showEditModal={showEditModal}
        showDeleteModal={showDeleteModal}
      />
      <CreateDateModal
        visible={createModalVisible}
        hide={hideCreateModal}
        onItemCreate={refreshData}
        calendarYear={selectedTab}
        calendarMonth={selectedMonth}
      />
      <EditDateModal
        visible={editModalVisible}
        hide={hideEditModal}
        onItemEdit={refreshData}
        calendarEvent={selectedCalendarEvent}
        calendarYear={selectedTab}
        calendarMonth={selectedMonth}
      />
      <DeleteDateModal
        visible={deleteModalVisible}
        hide={hideDeleteModal}
        onItemDelete={refreshData}
        calendarEvent={selectedCalendarEvent}
      />
    </>
  );
};
